import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { bus } from "../../../../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "id",
					title: "id",
					configId: ""
				},
				{
					field: "localization",
					title: "",
					configId: "",
					width: "50",
					headerCell: "myHeaderTemplate",
					cell: "myImageCellTemplate",
					editable: false,
					sortable: false,
					filterable: false,
					configByPass: true,
					order: 0
				},
				{
					field: "number_plate",
					title: "targa",
					configId: "numberPlate",
					width: "100",
					//headerCell: "myLicensePlateHeaderTemplate",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					title: "codice",
					configId: "vehicleCode",
					width: "130",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicleName",
					width: "205",
					//headerCell: "myDriverHeaderTemplate",
					headerCell: "myHeaderTemplate",
					format: "",
					sortable: false,
					filterable: false
				},
				{
					field: "driver_name",
					title: "conducente",
					configId: "driverName",
					width: "205",
					//headerCell: "myDriverHeaderTemplate",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "first_start_date",
					title: "prima data partenza",
					configId: "firstStartDate",
					width: "190",
					headerCell: "myHeaderTemplate",
					format: "datetime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "last_start_date",
					title: "ultima data ora arrivo",
					configId: "lastEndDate",
					width: "190",
					headerCell: "myHeaderTemplate",
					format: "datetime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_trip_time",
					title: "tempo viaggio",
					configId: "totalTripTime",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "secondsToTime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_drive_time",
					title: "tempo movimento",
					configId: "totalDriveTime",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "secondsToTime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_idle_time",
					title: "tempo inattività",
					configId: "totalIdleTime",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "secondsToTime",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_gps_km",
					title: "km gps",
					configId: "totalGpsKm",
					width: "180",
					format: "numeric",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: false,
					sortable: false
				},
				{
					field: "total_path_km",
					title: "km path",
					configId: "totalPathKm",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false,
					tag: "no_valid_path_km"
				},
				{
					field: "total_interpolated_km",
					title: "km interpolati",
					configId: "totalInterpolatedKm",
					width: "150",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false,
					tag: "no_valid_interpolated_km"
				},
				{
					field: "max_speed",
					title: "veloc. max",
					configId: "maxSpeed",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false,
					tag: "no_positions"
				},
				{
					field: "avg_speed",
					title: "veloc. media",
					configId: "avgSpeed",
					width: "140",
					headerCell: "myHeaderTemplate",
					format: "numeric",
					cell: "myCellTemplate",
					filterable: false,
					sortable: false,
					tag: "no_positions"
				},
				{
					field: "number_of_trips",
					title: "n. viaggi",
					configId: "numberOfTrips",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "start_location_display_name",
					title: "luogo iniziale",
					configId: "startLocation",
					width: "250",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "myStartPositionDisplayName",
					filterable: false,
					sortable: false
				},
				{
					field: "end_location_display_name",
					title: "luogo iniziale",
					configId: "endLocation",
					width: "250",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "myEndPositionDisplayName",
					filterable: false,
					sortable: false
				},
				{
					field: "avg_fuel_consumption",
					title: "consumo medio",
					configId: "avgFuelConsumption",
					width: "270",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				},
				{
					field: "fuel_consumption_km_lt",
					title: "Consumo KM/LT",
					configId: "fuelConsumptionKmLt",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false,
					tag: "no_valid_lt",
					sortable: false
				}
			],

			config: [],
			items: [],

			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles",
			vehicleIdFilterFieldColumn: "number_plate",

			notHasTripsDataPermission: true
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldColumn = "vehicle_code";
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}

		if (this.scopes && this.scopes.length > 0) {
			this.notHasTripsDataPermission =
				this.scopes.some(item => {
					return item == "TRIPS_DATA";
				}) == false;
		}
	},
	mounted() {
		this.getConfig();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.skip = 0;
		// 		this.query.page = 0;
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.skip = 0;
			this.query.page = 0;
			this.getData();
		},
		goToTripsData(number_plate, pathId, statusDate) {
			if (this.notHasTripsDataPermission == false) {
				var startDateFilter = null;

				var lastStatusDate = moment(statusDate);
				var now = moment();
				var timeToOff = "";

				var diff = now.diff(lastStatusDate, "days");
				if (diff == 0) {
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId
						}
					});
				} else {
					startDateFilter = lastStatusDate.startOf("day");
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId,
							startDay: startDateFilter.utc().format()
						}
					});
				}
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_trips")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportXlsx("report/trips/synthetic", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Report_Viaggi_sintetico.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getTripsSynthetic(data).then(res => {
				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						if (
							c.tag &&
							item.tags &&
							item.tags.some(tag => {
								return tag == c.tag;
							})
						) {
							row[c.field] = "(*)";
						} else {
							row[c.field] = item[c.field];
						}
					});
					return row;
				});

				self.total = res.totalCount;

				self.$emit("on-loading", false);
			});
		},
		getRequestData() {
			var self = this;
			var data = this._.clone(this.query);

			if (this.columnFilters) {
				for (var i = 0; i < this.columnFilters.length; i++) {
					var clmF = this.columnFilters[i];

					for (var j = 0; j < clmF.filter.filters.length; j++) {
						var filt = clmF.filter.filters[j];
						var field = filt.field;
						var value = filt.value;

						data[field] = value;
					}
				}
			}

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;

						default:
							break;
					}
				});
			}

			return data;
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						var index = columnsByPassConfig[i].order || 0;
						self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"])
	}
};
